
import environment from "../configurations/environment";

export const LogoutRedirect = () => {
  window.location.replace(environment.logoutUrl); // Simulate an HTTP redirect
  return "Redirecting...";
};
